import Api from '@/utils/api'
import i18n from '@/utils/i18n'

function debounce(func, wait, immediate) {
  var timeout
  return function () {
    const context = this
    const args = arguments
    const later = function () {
      timeout = null
      if (!immediate) {
        func.apply(context, args)
      }
    }
    var callNow = immediate && !timeout
    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
    if (callNow) {
      func.apply(context, args)
    }
  }
}

export default class Datasource {
  constructor(namespace, args) {
    this.namespace = namespace
    this.loading = false
    this.labelNamespace = (args.labelNamespace || this.namespace).replace(
      '/',
      '',
    )
    this.pagination = {
      page: args.page || null,
      rowsPerPage: args.rowsPerPage || null,
      sortBy: args.sortBy,
      descending: args.descending,
    }
    this.args = args.args || {}
    this.items = args.items || []
    this.totalRows = args.totalRows || 0
    this.totalSubRows = args.totalSubRows || 0
    this.showSelect = args.showSelect
    this.showExpand = args.showExpand
    this.customRowClass = args.customRowClass
    this.linkClass = args.linkClass
    this.noDataText = args.noDataText
    ;(this.noResultsText = args.noResultsText),
      (this.fields = args.fields
        ? args.fields.map((f) => {
            if (typeof f === 'string') {
              return this.addDefaultClasses({
                value: f,
              })
            } else {
              return this.addDefaultClasses(f)
            }
          })
        : undefined)
    this.debouncedRefresh = debounce(this.refresh, 200)
  }

  addDefaultClasses(field) {
    if (field.value === '_select') {
      field.icon = 'edit'
    } else if (field.value === '_add') {
      field.icon = 'add'
    } else if (field.value === '_link') {
      field.icon = 'link'
    } else if (field.value === '_alarms') {
      field.icon = 'warning'
    } else if (field.value === '_delete') {
      field.icon = 'delete'
    } else if (field.value === '_calendar') {
      field.icon = 'view_agenda'
    }

    if (field.icon) {
      field.sortable = false
      field.width = '20px'
    } else if (field.particular) {
      return field
    } else {
      if (!field.text) {
        field.text = i18n.t(this.labelNamespace + '.headers.' + field.value)
      }
    }
    return field
  }

  linkTo(item) {
    return {
      name: this.namespace + '/detail',
      params: {
        id: item.id,
      },
    }
  }

  selecteds() {
    return this.items.filter((item) => item.selected)
  }

  selectedsCount() {
    return this.selecteds().length
  }

  noneSelecteds() {
    return !this.hasSelecteds()
  }

  hasSelecteds() {
    return this.selectedsCount() > 0
  }

  refresh() {
    if (!this.namespace) {
      return
    }

    const me = this
    const input = {
      params: {
        ...this.args,
        page: this.pagination.page ? this.pagination.page - 1 : null,
        size: this.pagination.rowsPerPage,
      },
    }

    if (this.pagination.sortBy) {
      input.params.sort =
        this.pagination.sortBy +
        ',' +
        (this.pagination.descending ? 'DESC' : 'ASC')
    }

    // FIXME gestion de l'annulation
    this.loading = true
    return new Api(this.namespace)
      .get(input)
      .then((response) => {
        const body = response.body
        me.items = body.items
        me.totalRows = body.totalRows
        me.totalSubRows = body.subTotal
      })
      .catch(() => {})
      .finally(() => {
        this.loading = false
      })
  }
}
